import type {ReactNode} from 'react'
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {SaveCancelFooter} from '@/components/shared/SaveCancelFooter'
import {useI18n} from '@/i18n'

interface DeleteConfirmDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    title: string
    description: ReactNode
    /** testId prefix for cancel + confirm buttons (e.g. "delete-system") */
    testIdPrefix: string
    onConfirm: () => void
    isPending?: boolean
    confirmLabel?: string
}

export function DeleteConfirmDialog({
    open,
    onOpenChange,
    title,
    description,
    testIdPrefix,
    onConfirm,
    isPending = false,
    confirmLabel,
}: DeleteConfirmDialogProps) {
    const i18n = useI18n()
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid={`${testIdPrefix}-dialog`}>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <SaveCancelFooter
                    testIdPrefix={testIdPrefix}
                    onCancel={() => onOpenChange(false)}
                    onSave={onConfirm}
                    saveType="button"
                    destructive
                    saving={isPending}
                    saveLabel={confirmLabel ?? i18n.common.delete}
                />
            </DialogContent>
        </Dialog>
    )
}
